import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { Fragment } from 'react';

import { MessageModalPanel } from '~extension/web2print/view/MessageModal/MessageModalPanel';

type MessageModalProps = {
  message: string;
  isOpen: boolean;
  onClose: () => void;
};

export function MessageModal({ isOpen, onClose, ...PanelProps }: MessageModalProps) {
  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog onClose={onClose} as="div" className="relative z-40">
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-50"
          leave="ease-in duration-200"
          leaveFrom="opacity-50"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black opacity-50" />
        </TransitionChild>
        <div className="fixed inset-0 p-8 flex justify-center items-center overflow-hidden">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95 translate-y-4"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95 translate-y-4"
          >
            <DialogPanel
              as={MessageModalPanel}
              {...PanelProps}
              onClose={onClose}
              className="transition-all transform"
            />
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
}
